var components
try {
  components = {
    uForm: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-form/u-form" */ "uview-ui/components/u-form/u-form.vue"
      )
    },
    uFormItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-form-item/u-form-item" */ "uview-ui/components/u-form-item/u-form-item.vue"
      )
    },
    uInput: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-input/u-input" */ "uview-ui/components/u-input/u-input.vue"
      )
    },
    uSwitch: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-switch/u-switch" */ "uview-ui/components/u-switch/u-switch.vue"
      )
    },
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
    uPicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-picker/u-picker" */ "uview-ui/components/u-picker/u-picker.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = true
    }
  }
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }